'use client';

import Image, { type StaticImageData } from 'next/image';

import idfcLogo from '@/images/banking-partner-images/idfc.png';
import iciciLogo from '@/images/banking-partner-images/icici.png';
import equitasLogo from '@/images/banking-partner-images/equitas.png';
import kotakLogo from '@/images/banking-partner-images/kotak.png';
import yesBankLogo from '@/images/banking-partner-images/yesbank.png';
import axisLogo from '@/images/banking-partner-images/axis.png';
import federalLogo from '@/images/banking-partner-images/Federal.png';
import ujjivanLogo from '@/images/banking-partner-images/Ujjivan.png';

import gropaymentsLogo from '@/images/Mainpage/client-logos/gropayments-logo.png';
import capsFinservLogo from '@/images/Mainpage/client-logos/caps-finserv-logo.png';
import thefabkitLogo from '@/images/Mainpage/client-logos/thefabkit-logo.svg';
import cleansLogo from '@/images/Mainpage/client-logos/cleans-logo.png';
import coolingSolutionsLogo from '@/images/Mainpage/client-logos/cooling-solutions-logo.webp';
import easyParkingLogo from '@/images/Mainpage/client-logos/easy-parking-logo.png';
import orangeMobilesLogo from '@/images/Mainpage/client-logos/orange-mobiles-logo.png';
import jetplusLogo from '@/images/Mainpage/client-logos/jetplus-logo.png';
import asifLogo from '@/images/Mainpage/client-logos/asif-logo.png';
import xtrageniusLogo from '@/images/Mainpage/client-logos/xtragenius-logo.png';
import truidLogo from '@/images/Mainpage/client-logos/truid-logo.png';
import vfsLogo from '@/images/Mainpage/client-logos/vfs-logo.webp';
import rinsopayLogo from '@/images/Mainpage/client-logos/rinsopay-logo.svg';
import krishnaSeedsLogo from '@/images/Mainpage/client-logos/krishna-seeds-logo.png';
import myCoach4uLogo from '@/images/Mainpage/client-logos/mycoach4u-logo.png';
import codeCampusEduLogo from '@/images/Mainpage/client-logos/codecampusedu-logo.png';
import glimmerLifestyleLogo from '@/images/Mainpage/client-logos/glimmer-lifestyle-logo.png';
import amityTechnologiesLogo from '@/images/Mainpage/client-logos/amity-technologies-logo.png';
import babaEnterprisesLogo from '@/images/Mainpage/client-logos/baba-enterprises-logo.webp';
import printVallyLogo from '@/images/Mainpage/client-logos/printvally-logo.png';
import neuRenewableEnergyLogo from '@/images/Mainpage/client-logos/neu-renewable-energy-logo.png';
import payQwickLogo from '@/images/Mainpage/client-logos/payqwick-logo.png';
import sreePonnanaTheyvamTrustLogo from '@/images/Mainpage/client-logos/sreeponantheivam.png';
import nammaTeaWorldLogo from '@/images/Mainpage/client-logos/namma-tea-world-logo.webp';
import stadiumSportsBarLogo from '@/images/Mainpage/client-logos/stadium-sports-bar-logo.png';
import hifiShoppingLogo from '@/images/Mainpage/client-logos/d2c-client-logos-white/hifi-shopping-white.png';
import kamakhyaWellnessLogo from '@/images/Mainpage/client-logos/d2c-client-logos-white/kamakhya-wellness-white.png';
import fasicaPowerSolutionsLogo from '@/images/Mainpage/client-logos/d2c-client-logos-white/fasica-power-solutions-white.png';
import macharryLogo from '@/images/Mainpage/client-logos/d2c-client-logos-white/macharry-white.png';
import gobraLogo from '@/images/Mainpage/client-logos/d2c-client-logos-white/gobra-white.png';

const BANKS: { src: StaticImageData; alt: string; href?: string }[] = [
  { src: idfcLogo, alt: 'IDFC FIRST Bank Logo' },
  { src: iciciLogo, alt: 'ICICI Bank Logo' },
  { src: equitasLogo, alt: 'Equitas Small Finance Bank Logo' },
  { src: kotakLogo, alt: 'Kotak Mahindra Bank Logo' },
  { src: yesBankLogo, alt: 'Yes Bank Logo' },
  { src: axisLogo, alt: 'Axis Bank Logo' },
  { src: federalLogo, alt: 'Federal Bank Logo' },
  { src: ujjivanLogo, alt: 'Ujjivan Small Finance Bank Logo' },
];

// Client logos, appended after the banks — same slider, one continuous row, matching the
// "Banking Partners & Our Clients" heading above it.
const CLIENTS: { src: StaticImageData; alt: string; href?: string }[] = [
  { src: gropaymentsLogo, alt: 'GroPayments Logo', href: 'https://gropayments.in/' },
  { src: capsFinservLogo, alt: 'Caps Finserv Logo', href: 'https://financialplanner.capsfinserv.com/' },
  { src: thefabkitLogo, alt: 'The Fabkit Logo', href: 'https://www.thefabkit.com/' },
  { src: cleansLogo, alt: 'Cleans Logo', href: 'https://www.cleanflowsystem.com/' },
  { src: coolingSolutionsLogo, alt: 'Cooling Solutions Logo', href: 'https://www.coolingsolutionschennai.com/' },
  { src: easyParkingLogo, alt: 'Easy Parking Logo', href: 'https://easyparkingltd.com/' },
  { src: orangeMobilesLogo, alt: 'Orange Mobiles Logo', href: 'https://orangemobilesrepair.co.uk/' },
  { src: jetplusLogo, alt: 'JetPlus Technology Logo', href: 'https://www.jetplustech.com/' },
  { src: asifLogo, alt: 'ASIF Logo', href: 'https://www.asif-in.fr/' },
  { src: xtrageniusLogo, alt: 'Xtragenius Logo', href: 'https://xtragenius.com/' },
  { src: truidLogo, alt: 'TruID Logo', href: 'https://truid.one/' },
  { src: vfsLogo, alt: 'Vijay Financial Services Logo', href: 'https://vijayfinancialservices.com/' },
  { src: rinsopayLogo, alt: 'RinsoPay Logo', href: 'https://rinsopay.in/' },
  { src: krishnaSeedsLogo, alt: 'Krishna Seeds Logo', href: 'https://www.krishnaseeds.in/' },
  { src: myCoach4uLogo, alt: 'MyCoach4U Logo' },
  { src: codeCampusEduLogo, alt: 'CodeCampusEdu Logo' },
  { src: glimmerLifestyleLogo, alt: 'Glimmer Lifestyle LLP Logo', href: 'https://glimmerlifestyle.in/' },
  { src: amityTechnologiesLogo, alt: 'Amity Technologies Logo', href: 'https://amityerp.pages.dev/' },
  { src: babaEnterprisesLogo, alt: 'Baba Enterprises Logo', href: 'http://babaindustrialgases.com/' },
  { src: printVallyLogo, alt: 'PrintVally Logo', href: 'https://www.printvally.com/' },
  { src: neuRenewableEnergyLogo, alt: 'NEU Renewable Energy Logo', href: 'https://neurenewableenergy.com/' },
  { src: payQwickLogo, alt: 'Pay Qwick Logo', href: 'https://payqwick.in/' },
  { src: sreePonnanaTheyvamTrustLogo, alt: 'Sree Ponnana Theyvam Trust Logo', href: 'https://www.sreeponnanatheyvamtrust.com/' },
  { src: nammaTeaWorldLogo, alt: 'Namma Tea World Logo' },
  { src: stadiumSportsBarLogo, alt: 'Stadium Sports Bar Logo' },
  { src: hifiShoppingLogo, alt: 'Hifi Shopping Logo', href: 'https://hifishopping.com/' },
  { src: kamakhyaWellnessLogo, alt: 'Kamakhya Wellness Logo', href: 'https://www.kamakhyawellness.com/' },
  { src: fasicaPowerSolutionsLogo, alt: 'Fasica Power Solutions Logo', href: 'https://fasicapowersolutions.com/' },
  { src: macharryLogo, alt: 'Mac Harry Logo', href: 'https://macharry.in/' },
  { src: gobraLogo, alt: 'Gobra Logo', href: 'https://gobrapaintsnextjs.pages.dev/' },
];

const BankingPartnersSlider = () => {
  // Same marquee mechanism as InterCustomerSlider.tsx (duplicated list + CSS marquee-track
  // animation translating -50%), just a different logo set — that component is untouched.
  const allLogos = [...BANKS, ...CLIENTS];
  const duplicatedBanks = [...allLogos, ...allLogos];

  return (
    <div className="overflow-hidden  relative z-20">
      <div
        className="marquee-track w-max flex items-center"
        style={{ animation: 'marqueeToLeft 300s linear infinite' }}
      >
        {duplicatedBanks.map((bank, index) =>
          bank.href ? (
            <a
              key={index}
              href={bank.href}
              target="_blank"
              rel="noopener noreferrer"
              title={bank.alt}
              className="flex-shrink-0 mx-4 flex h-[150px] w-[180px] items-center justify-center rounded-xl p-4 transition-transform hover:-translate-y-0.5"
            >
              <Image
                src={bank.src}
                className="h-full w-full object-contain"
                alt={bank.alt}
              />
            </a>
          ) : (
            <div
              key={index}
              className="flex-shrink-0 mx-4 flex h-[150px] w-[180px] items-center justify-center rounded-xl p-4"
            >
              <Image
                src={bank.src}
                className="h-full w-full object-contain"
                alt={bank.alt}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default BankingPartnersSlider;
